import React from 'react';
import { TableCellMobile as CellMobile } from 'src/components';
import { getTableRowColor } from '../../services';
import { MandatesListType } from 'src/pages/Mandates/models';

interface Props {
  type: MandatesListType;
  children: React.ReactNode;
}

const TableCellMobile = ({ type, children }: Props) => {
  const color = getTableRowColor(type);

  return <CellMobile color={color}>{children}</CellMobile>;
};

export default TableCellMobile;
